import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { UserCog, LogOut } from "lucide-react";

export default function ImpersonationBanner() {
  const { isImpersonating, org, endImpersonation } = useAuth();
  if (!isImpersonating) return null;

  // v1.2 PR-C.2 — Do NOT force-navigate after ending impersonation. The
  // AuthContext.refresh() that runs inside endImpersonation() updates
  // `effective_org_id` to null, which flips `noOrgSuperAdmin` to true in
  // the route-level `<OrgScopedRoute>` wrapper — that wrapper then swaps
  // the page body to <OrgScopeEmptyState/> **on the same URL**. No reload,
  // no flash of the impersonated org's stale data, no jump to /super-admin.
  const stop = async () => {
    await endImpersonation();
  };

  return (
    <div
      className="w-full bg-warning/20 border-b border-warning/40 text-navy-900 py-2.5 px-6 flex justify-between items-center sticky top-0 z-40 backdrop-blur"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 text-sm font-medium">
        <UserCog className="w-4 h-4 text-warning" />
        Impersonating <strong className="ml-1">{org?.name || "Organisation"}</strong>
      </div>
      <button
        onClick={stop}
        data-testid="end-impersonation-btn"
        className="inline-flex items-center gap-1.5 text-xs font-semibold bg-white border border-warning/40 text-navy-900 rounded-md px-3 py-1.5 hover:bg-warning/10 transition-colors"
      >
        <LogOut className="w-3 h-3" />
        End impersonation
      </button>
    </div>
  );
}
